import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { insurancePartners } from '../mock';

const InsurancePartners = () => {
  const { language } = useLanguage();

  return (
    <section className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            {language === 'en' 
              ? 'Hablamos Español. Servimos a Todos.'
              : 'Hablamos Español. Servimos a Todos.'}
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            {language === 'en'
              ? 'At Palerm Insurance Agency, we are dedicated to providing customer-first service. More than just representatives, we are your dedicated guides, committed to helping you find the best insurance solutions tailored to your needs. Rooted in our Hispanic heritage and dedicated to serving a diverse clientele, we’re here to protect what matters most to you.'
              : 'En Palerm Insurance Agency, nos dedicamos a brindar un servicio centrado en el cliente. Más que solo representantes, somos sus guías dedicados, comprometidos a ayudarlo a encontrar las mejores soluciones de seguro adaptadas a sus necesidades. Arraigados en nuestra herencia hispana y dedicados a servir a una clientela diversa, estamos aquí para proteger lo que más le importa.'}
          </p>
        </div>

        {/* Partner Logos */}
        <div className="relative overflow-hidden">
          <div className="flex animate-scroll-partners gap-8 items-center py-8">
            {[...insurancePartners, ...insurancePartners, ...insurancePartners].map((partner, index) => (
              <div
                key={`partner-${index}`}
                className="flex-shrink-0 w-40 h-24 bg-white rounded-lg shadow-md hover:shadow-xl transition-all duration-300 p-4 flex items-center justify-center"
              >
                <img
                  src={partner.logo}
                  alt={partner.name}
                  className="max-w-full max-h-full object-contain"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 40'%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' font-family='Arial' font-size='12' fill='%23666'%3E${partner.name}%3C/text%3E%3C/svg%3E`;
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default InsurancePartners;